const ReadMeModule = () => {
  return (
    <div>
      <h4>대회 설명 영역</h4>
    </div>
  );
};

export default ReadMeModule;
